export const CirgsPolicies = ['AP - 695901', 'AP - 695902', 'AP - 696576', 'VG - 695211', 'VG - 695213', 'VG - 695996'];
